import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    analyticsPerpayCreditCardRewardsNotificationViewed,
    analyticsPerpayCreditCardRewardsNotificationClickCta,
    analyticsPerpayCreditCardRewardsNotificationClose,
} from '@perpay-web/fintech/actions/analytics/perpayCreditCardRewardsNotification';
import { fetchUserInfo } from '@perpay-web/fintech/actions/entities/userInfo';
import CardRewardsNotification from '@perpay-web/fintech/components/composite/CardRewardsNotification/CardRewardsNotification';
import {
    getFirstName,
    getIsAvailable,
} from '@perpay-web/fintech/selectors/entities/userInfo';

/**
 * Container component for CardRewardsNotification
 * @param {Object} props - Component props
 * @param {number} [props.cardRewardsAmount] - Card rewards amount
 * @returns {JSX.Element} CardRewardsNotification component
 */
const CardRewardsNotificationContainer = ({ cardRewardsAmount }) => {
    const dispatch = useDispatch();

    const firstName = useSelector(getFirstName);
    const isLoading = useSelector(getIsAvailable);

    const onMount = useCallback(() => {
        dispatch(fetchUserInfo());
        dispatch(analyticsPerpayCreditCardRewardsNotificationViewed());
    }, [dispatch]);

    const analyticsOnClose = useCallback(
        () => dispatch(analyticsPerpayCreditCardRewardsNotificationClose()),
        [dispatch],
    );

    const analyticsOnClickCta = useCallback(
        () => dispatch(analyticsPerpayCreditCardRewardsNotificationClickCta()),
        [dispatch],
    );

    return (
        <CardRewardsNotification
            isLoading={isLoading}
            firstName={firstName}
            cardRewardsAmount={cardRewardsAmount}
            onMount={onMount}
            analyticsOnClose={analyticsOnClose}
            analyticsOnClickCta={analyticsOnClickCta}
        />
    );
};

export default CardRewardsNotificationContainer;
